"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ValueLabel = void 0;
const react_i18next_1 = require("react-i18next");
const react_1 = __importDefault(require("react"));
const broadCastLogo_svg_1 = __importDefault(require("../../../../../assets/icons/broadCastLogo.svg"));
const thresholdColors_1 = require("../../../../../utils/thresholdColors");
const S = __importStar(require("./ValueLabel.style"));
const hooks_1 = require("../../../../../store/hooks");
const thresholdSlice_1 = require("../../../../../store/thresholdSlice");
const ValueLabel = ({ date, value, unitSymbol, isActive }) => {
    const { t } = (0, react_i18next_1.useTranslation)();
    const thresholds = (0, hooks_1.useAppSelector)(thresholdSlice_1.selectThresholds);
    const averageValueColor = (0, thresholdColors_1.getColorForValue)(thresholds, value !== null && value !== void 0 ? value : -1000);
    const dataCardColor = (0, thresholdColors_1.getColorForCalendarDataCard)(averageValueColor);
    return (react_1.default.createElement(S.Container, { "$isActive": isActive, "$color": dataCardColor },
        react_1.default.createElement(S.ImageContainer, { src: broadCastLogo_svg_1.default, alt: t("stationValue.altLogo") }),
        react_1.default.createElement(S.TextContainer, null,
            react_1.default.createElement(S.Label, null, t("stationValue.avgPlaceholder", { date: date })),
            react_1.default.createElement(S.Header, null, value),
            react_1.default.createElement(S.Label, null, unitSymbol))));
};
exports.ValueLabel = ValueLabel;
